webpackJsonp([263791100135453],{

/***/ 270:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.4
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(270);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CertificateIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CertificateIcon = exports.CertificateIcon = function CertificateIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '0 0 48 44' }, props),
	    _react2.default.createElement('path', { d: 'M4 8H0V0h8v4H6V2H2v4h2zM48 8h-4V6h2V2h-4v2h-2V0h8zM10 1h28v2H10zM8 36H0v-8h4v2H2v4h4v-2h2zM48 36h-8v-4h2v2h4v-4h-2v-2h4zM10 33h8v2h-8zM30 33h8v2h-8zM1 10h2v16H1zM45 10h2v16h-2zM27 44c-.194 0-.388-.057-.555-.168L24 42.202l-2.445 1.63c-.308.204-.703.223-1.026.05A.9994.9994 0 0 1 20 43V33c0-.553.448-1 1-1s1 .447 1 1v8.132l1.445-.964a.9954.9954 0 0 1 1.109 0l1.446.964V33c0-.553.447-1 1-1s1 .447 1 1v10c0 .369-.203.708-.528.882-.148.079-.31.118-.472.118zM13 9h22v2H13zM17 13h14v2H17z' }),
	    _react2.default.createElement('path', { d: 'M25.771 34c-.466 0-.931-.115-1.347-.333-.259-.137-.578-.136-.836-.001-.414.219-.88.334-1.345.334-1.185 0-2.243-.712-2.696-1.815-.115-.279-.357-.485-.648-.551-.792-.179-1.478-.685-1.885-1.39a2.9647 2.9647 0 0 1-.264-2.354.9542.9542 0 0 0-.15-.858c-.494-.651-.696-1.489-.554-2.297.142-.804.614-1.518 1.297-1.958.252-.163.411-.443.424-.749.073-1.702 1.567-3.014 3.291-2.783.299.04.588-.072.786-.291.55-.606 1.334-.954 2.151-.954.816 0 1.6.348 2.152.955.199.22.489.328.789.292 1.712-.228 3.216 1.08 3.292 2.78.015.306.174.587.428.751.683.44 1.156 1.154 1.299 1.958.143.807-.058 1.644-.552 2.295-.184.243-.238.563-.146.857.244.785.149 1.644-.261 2.355a2.9259 2.9259 0 0 1-1.883 1.39c-.291.065-.532.271-.647.551C28.015 33.287 26.957 34 25.771 34zm-1.765-2.437c.468 0 .934.114 1.348.333.465.24 1.061.015 1.26-.47.364-.886 1.134-1.536 2.06-1.744.249-.057.459-.212.589-.438a.943.943 0 0 0 .083-.761c-.283-.909-.11-1.903.462-2.66a.939.939 0 0 0 .177-.739c-.046-.262-.192-.484-.413-.626-.796-.514-1.298-1.389-1.342-2.341-.024-.545-.505-.961-1.031-.889-.958.125-1.896-.229-2.533-.93-.35-.385-.991-.386-1.341 0-.55.607-1.333.956-2.15.956-.126 0-.253-.008-.38-.025-.537-.072-1.007.343-1.03.886-.041.954-.541 1.83-1.338 2.344-.219.141-.365.362-.411.624-.046.265.017.527.178.74.574.757.749 1.751.467 2.659-.08.258-.05.528.085.761.131.227.341.383.593.439.925.208 1.695.858 2.059 1.741.2.487.792.716 1.262.473.412-.218.879-.333 1.346-.333z' }),
	    _react2.default.createElement('path', { d: 'M24.008 30c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.898-2-2-2z' })
	  );
	};
	
	CertificateIcon.displayName = 'CertificateIcon';
	
	exports.default = (0, _styledComponents2.default)(CertificateIcon)(_templateObject);

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  transition: opacity 0.5s;\n  width: 100%;\n  height: 100%;\n'], ['\n  transition: opacity 0.5s;\n  width: 100%;\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  overflow: visible;\n  position: relative;\n  max-width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  @media (min-height: ', ') {\n    height: ', ';\n  }\n  max-height: ', ';\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n'], ['\n  background-color: ', ';\n  overflow: visible;\n  position: relative;\n  max-width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  @media (min-height: ', ') {\n    height: ', ';\n  }\n  max-height: ', ';\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(127);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	
	var Hero = exports.Hero = function (_Component) {
	  _inherits(Hero, _Component);
	
	  function Hero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidUpdate = function (prevProps) {
	      var isFullHeight = _this.props.isFullHeight;
	
	      if (isFullHeight !== prevProps.isFullHeight && _this.elm && _this.elm.animate) {
	        if (isFullHeight) {
	          _this.elm.animate([{ height: '20vh' }, { height: '70vh' }], {
	            duration: 300,
	            fill: 'forwards',
	            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	            iterations: 1
	          });
	        } else {
	          _this.elm.animate([{ height: '70vh' }, { height: '20vh' }], {
	            duration: 300,
	            fill: 'forwards',
	            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	            iterations: 1
	          });
	        }
	      }
	    }, _this.setRef = function (elm) {
	      // eslint-disable-next-line react/no-find-dom-node
	      _this.elm = _reactDom2.default.findDOMNode(elm);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Hero.prototype.render = function render() {
	    var _props = this.props,
	        bgColor = _props.bgColor,
	        selectedImage = _props.selectedImage,
	        bgImages = _props.bgImages,
	        isFullHeight = _props.isFullHeight,
	        children = _props.children,
	        opacity = _props.opacity,
	        imgStyle = _props.imgStyle,
	        Tag = _props.tag,
	        rest = _objectWithoutProperties(_props, ['bgColor', 'selectedImage', 'bgImages', 'isFullHeight', 'children', 'opacity', 'imgStyle', 'tag']);
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({ ref: this.setRef }, rest),
	      children,
	      bgImages.map(function (image) {
	        return _react2.default.createElement(BackgroundImage, {
	          key: image.sizes.src,
	          style: {
	            opacity: selectedImage.sizes.src === image.sizes.src ? '1' : '0'
	          },
	          sizes: image.sizes,
	          opacity: opacity,
	          imgStyle: imgStyle
	        });
	      })
	    );
	  };
	
	  return Hero;
	}(_react.Component);
	
	Hero.displayName = 'Hero';
	Hero.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  children: _propTypes2.default.node,
	  isFullHeight: _propTypes2.default.bool,
	  selectedImage: CustomPropTypes.ImageSharp.isRequired,
	  bgColor: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  bgImages: _propTypes2.default.arrayOf(CustomPropTypes.ImageSharp),
	  imgStyle: _propTypes2.default.shape({
	    objectPosition: _propTypes2.default.string
	  })
	};
	Hero.defaultProps = {
	  tag: 'header',
	  bgColor: _vars.COLORS.bg,
	  opacity: 1,
	  bgImages: []
	};
	exports.default = (0, _styledComponents2.default)(Hero)(_templateObject2, function (props) {
	  return props.bgColor;
	}, (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH_PLUS), (0, _utils.pxToRem)(450), function (_ref) {
	  var isFullHeight = _ref.isFullHeight;
	  return isFullHeight ? '70vh' : '20vh';
	}, (0, _utils.pxToRem)(460));

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeroContent = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 2;\n'], ['\n  position: relative;\n  z-index: 2;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeroContent = function HeroContent(_ref) {
	  var Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, rest);
	};
	
	exports.HeroContent = HeroContent;
	HeroContent.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	HeroContent.defaultProps = {
	  tag: 'div'
	};
	
	HeroContent.displayName = 'HeroContent';
	
	exports.default = (0, _styledComponents2.default)(HeroContent)(_templateObject);

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeroHomePageContent = exports.StyledContentWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  width: 100%;\n  background-color: ', ';\n  margin: 0;\n  height: calc(100% + ', ');\n  padding: ', ' ', ' ', ';\n\n  @media (min-width: ', ') {\n    width: 75%;\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n\n  @media (min-width: ', ') {\n    width: 50%;\n  }\n\n  @media (min-width: ', ') {\n    padding-left: ', ';\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  width: 100%;\n  background-color: ', ';\n  margin: 0;\n  height: calc(100% + ', ');\n  padding: ', ' ', ' ', ';\n\n  @media (min-width: ', ') {\n    width: 75%;\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n\n  @media (min-width: ', ') {\n    width: 50%;\n  }\n\n  @media (min-width: ', ') {\n    padding-left: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  color: #fff;\n  display: flex;\n  justify-content: flex-end;\n'], ['\n  height: 100%;\n  color: #fff;\n  display: flex;\n  justify-content: flex-end;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _HeroContent = __webpack_require__(120);
	
	var _HeroContent2 = _interopRequireDefault(_HeroContent);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ContentWrapper = function ContentWrapper(_ref) {
	  var Tag = _ref.tag,
	      props = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, props);
	};
	
	ContentWrapper.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	ContentWrapper.defaultProps = {
	  tag: 'div'
	};
	
	ContentWrapper.displayName = 'ContentWrapper';
	
	var StyledContentWrapper = exports.StyledContentWrapper = (0, _styledComponents2.default)(ContentWrapper)(_templateObject, (0, _tinycolor2.default)(_vars.COLORS.brand[0]).setAlpha(0.9).toRgbString(), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 3), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroL), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 3), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 3), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroXL), (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH), (0, _utils.pxToRem)(1 / 12 * _vars.MAX_CONTENT_WIDTH));
	
	var HeroHomePageContent = function HeroHomePageContent(_ref2) {
	  var innerTag = _ref2.innerTag,
	      innerClassName = _ref2.innerClassName,
	      children = _ref2.children,
	      rest = _objectWithoutProperties(_ref2, ['innerTag', 'innerClassName', 'children']);
	
	  return _react2.default.createElement(
	    _HeroContent2.default,
	    rest,
	    _react2.default.createElement(
	      StyledContentWrapper,
	      { tag: innerTag, className: innerClassName },
	      children
	    )
	  );
	};
	
	exports.HeroHomePageContent = HeroHomePageContent;
	HeroHomePageContent.propTypes = {
	  innerTag: CustomPropTypes.Tag,
	  innerClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	HeroHomePageContent.displayName = 'HeroHomePageContent';
	
	exports.default = (0, _styledComponents2.default)(HeroHomePageContent)(_templateObject2);

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TrphyIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TrphyIcon = exports.TrphyIcon = function TrphyIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '0 0 38 47' }, props),
	    _react2.default.createElement(
	      'title',
	      null,
	      'Trophy icon'
	    ),
	    _react2.default.createElement('path', { d: 'M25 35h-2v-4c0-2.805 2.114-4.5 3.979-5.996C28.601 23.705 30 22.582 30 21V2H8v19c0 1.582 1.4 2.705 3.021 4.004C12.886 26.5 15 28.195 15 31v4h-2v-4c0-1.845-1.569-3.104-3.23-4.436C8.002 25.147 6 23.542 6 21V0h26v21c0 2.542-2.003 4.147-3.77 5.564C26.569 27.896 25 29.155 25 31v4z' }),
	    _react2.default.createElement('path', { d: 'M6 20H4.828c-.801 0-1.555-.312-2.121-.879l-1.242-1.242C.52 16.935 0 15.679 0 14.343V5h7v2H2v7.343c0 .802.312 1.555.879 2.122l1.242 1.242c.187.186.444.293.707.293H6v2zM33.172 20H32v-2h1.172c.263 0 .521-.107.707-.293l1.242-1.242c.567-.567.879-1.32.879-2.122V7h-5V5h7v9.343c0 1.336-.521 2.592-1.465 3.536l-1.242 1.242c-.566.567-1.32.879-2.121.879zM28 40h-2v-3c0-.552-.448-1-1-1h-3v-2h3c1.654 0 3 1.346 3 3v3zM12 40h-2v-3c0-1.654 1.346-3 3-3h7v2h-7c-.551 0-1 .448-1 1v3z' }),
	    _react2.default.createElement('path', { d: 'M31 47H7v-5c0-1.654 1.346-3 3-3h11v2H10c-.551 0-1 .448-1 1v3h20v-3c0-.552-.448-1-1-1h-5v-2h5c1.654 0 3 1.346 3 3v5zM23.329 21.948c-.184 0-.367-.05-.529-.152l-3.792-2.368-3.791 2.368a.995.995 0 0 1-1.114-.037.9998.9998 0 0 1-.388-1.045l1.081-4.489-3.454-3.16a1.0024 1.0024 0 0 1-.267-1.075c.136-.379.487-.64.889-.661l4.423-.231 1.686-4.452c.147-.389.519-.646.935-.646s.788.257.936.646l1.686 4.452 4.424.232c.402.021.753.282.889.661s.031.803-.267 1.075l-3.455 3.16 1.082 4.488c.095.395-.059.808-.388 1.046a1.011 1.011 0 0 1-.586.188zm-8.876-8.747l2.127 1.947c.269.246.383.618.297.972l-.646 2.685 2.246-1.403a1.001 1.001 0 0 1 1.059 0l2.247 1.403-.647-2.684a.9996.9996 0 0 1 .298-.972l2.128-1.946-2.69-.141a1 1 0 0 1-.883-.645l-.981-2.592-.982 2.592c-.14.371-.487.624-.883.645l-2.69.139z' })
	  );
	};
	
	TrphyIcon.displayName = 'TrphyIcon';
	
	exports.default = (0, _styledComponents2.default)(TrphyIcon)(_templateObject);

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Type4 = undefined;
	
	var _vars = __webpack_require__(5);
	
	var _typeComponentFactory = __webpack_require__(65);
	
	var _typeComponentFactory2 = _interopRequireDefault(_typeComponentFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var result = (0, _typeComponentFactory2.default)(_vars.TYPE_SIZE.t4, {
	  defaultTag: 'h4',
	  displayName: 'Type4'
	});
	
	var Type4 = exports.Type4 = result.Type;
	
	exports.default = result.StyledType;

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  line-height: ', ';\n  margin-bottom: 3rem;\n\n  p:last-of-type {\n    margin-bottom: 3rem;\n  }\n\n  ul {\n    text-align: center;\n    @media (min-width: ', ') {\n      columns: 2;\n    }\n  }\n\n  @media (min-width: ', ') {\n    text-align: center;\n  }\n'], ['\n  font-size: ', ';\n  line-height: ', ';\n  margin-bottom: 3rem;\n\n  p:last-of-type {\n    margin-bottom: 3rem;\n  }\n\n  ul {\n    text-align: center;\n    @media (min-width: ', ') {\n      columns: 2;\n    }\n  }\n\n  @media (min-width: ', ') {\n    text-align: center;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  align-items: center;\n  margin-bottom: 3rem;\n\n  @media (min-width: ', ') {\n    grid-template-columns: 1fr 3fr;\n  }\n\n  ', ' {\n    margin-top: 2rem;\n    padding: 2rem;\n    background-color: ', ';\n\n    @media (min-width: ', ') {\n      margin-top: 0;\n    }\n  }\n'], ['\n  display: grid;\n  align-items: center;\n  margin-bottom: 3rem;\n\n  @media (min-width: ', ') {\n    grid-template-columns: 1fr 3fr;\n  }\n\n  ', ' {\n    margin-top: 2rem;\n    padding: 2rem;\n    background-color: ', ';\n\n    @media (min-width: ', ') {\n      margin-top: 0;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  justify-self: center;\n  text-align: center;\n'], ['\n  justify-self: center;\n  text-align: center;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  fill: #333e4f;\n  width: ', ';\n'], ['\n  fill: #333e4f;\n  width: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  padding-left: ', ';\n  padding-right: ', ';\n\n  ', ' {\n    margin-top: 1.25rem;\n  }\n\n  ', ' {\n    font-size: ', ';\n    line-height: ', ';\n  }\n'], ['\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  padding-left: ', ';\n  padding-right: ', ';\n\n  ', ' {\n    margin-top: 1.25rem;\n  }\n\n  ', ' {\n    font-size: ', ';\n    line-height: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  padding: ', ';\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n  max-width: ', ';\n\n  @media (min-width: ', ') {\n    margin-top: 0;\n\n    ', ' {\n      max-width: calc(25% - ', ');\n    }\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      max-width: calc(50% - ', ');\n    }\n  }\n'], ['\n  background-color: ', ';\n  padding: ', ';\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n  max-width: ', ';\n\n  @media (min-width: ', ') {\n    margin-top: 0;\n\n    ', ' {\n      max-width: calc(25% - ', ');\n    }\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      max-width: calc(50% - ', ');\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 3rem;\n\n  @media (min-width: ', ') {\n    display: flex;\n  }\n\n  @media (min-width: ', ') {\n    margin-left: ', ';\n  }\n\n  ', ' {\n    fill: #333e4f;\n    width: ', ';\n  }\n'], ['\n  margin-bottom: 3rem;\n\n  @media (min-width: ', ') {\n    display: flex;\n  }\n\n  @media (min-width: ', ') {\n    margin-left: ', ';\n  }\n\n  ', ' {\n    fill: #333e4f;\n    width: ', ';\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 2rem;\n  background-color: ', ';\n  flex-basis: ', ';\n  margin-bottom: 2rem;\n\n  @media (min-width: ', ') {\n    margin-right: ', ';\n    margin-bottom: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 2rem;\n  background-color: ', ';\n  flex-basis: ', ';\n  margin-bottom: 2rem;\n\n  @media (min-width: ', ') {\n    margin-right: ', ';\n    margin-bottom: 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding-top: 2rem;\n'], ['\n  padding-top: 2rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageContainer = __webpack_require__(116);
	
	var _PageContainer2 = _interopRequireDefault(_PageContainer);
	
	var _MarkdownBlock = __webpack_require__(115);
	
	var _MarkdownBlock2 = _interopRequireDefault(_MarkdownBlock);
	
	var _TrophyIcon = __webpack_require__(402);
	
	var _TrophyIcon2 = _interopRequireDefault(_TrophyIcon);
	
	var _CertificateIcon = __webpack_require__(393);
	
	var _CertificateIcon2 = _interopRequireDefault(_CertificateIcon);
	
	var _Type = __webpack_require__(71);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _HeroHomePageContent = __webpack_require__(310);
	
	var _HeroHomePageContent2 = _interopRequireDefault(_HeroHomePageContent);
	
	var _Hero = __webpack_require__(134);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _utils = __webpack_require__(6);
	
	var _vars = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Intro = (0, _styledComponents2.default)(_MarkdownBlock2.default)(_templateObject, (0, _utils.pxToRem)(_vars.TYPE_SIZE.t4[0]), _vars.TYPE_SIZE.t4[1], (0, _utils.pxToRem)(750), (0, _utils.pxToRem)(900));
	
	var Awards = _styledComponents2.default.section(_templateObject2, (0, _utils.pxToRem)(750), _MarkdownBlock2.default, _vars.COLORS.gray[1], (0, _utils.pxToRem)(750));
	
	var AwardHeader = _styledComponents2.default.header(_templateObject3);
	
	var AwardIcon = (0, _styledComponents2.default)(_TrophyIcon2.default)(_templateObject4, (0, _utils.pxToRem)(104));
	
	var Mission = (0, _styledComponents2.default)(function (_ref) {
	  var className = _ref.className,
	      missionHtml = _ref.missionHtml;
	  return _react2.default.createElement(
	    _HeroHomePageContent2.default,
	    { innerClassName: className },
	    _react2.default.createElement(
	      _Type2.default,
	      { tag: 'h1', uppercase: true, weight: 'bold' },
	      'Our Mission'
	    ),
	    _react2.default.createElement(_MarkdownBlock2.default, { tag: 'section', dangerouslySetInnerHTML: { __html: missionHtml } })
	  );
	})(_templateObject5, (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2), _Type2.default, _MarkdownBlock2.default, (0, _utils.pxToRem)(_vars.TYPE_SIZE.t5[0]), _vars.TYPE_SIZE.t5[1]);
	
	var History = _styledComponents2.default.section(_templateObject6, _vars.COLORS.gray[1], (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)((0, _utils.grids)(10)), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroL), _Type2.default, (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 1.5), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroXL), _Type2.default, (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 1.5));
	
	var Certs = _styledComponents2.default.section(_templateObject7, (0, _utils.pxToRem)(750), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroXL), (0, _utils.pxToRem)(_vars.GRID_SIZE), _CertificateIcon2.default, (0, _utils.pxToRem)(104));
	
	var CertHGroup = _styledComponents2.default.hgroup(_templateObject8, _vars.COLORS.gray[1], (0, _utils.pxToRem)((0, _utils.grids)(3)), (0, _utils.pxToRem)(750), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2));
	
	var About = function (_React$PureComponent) {
	  _inherits(About, _React$PureComponent);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        data = _props.data;
	
	
	    return _react2.default.createElement(
	      _PageContainer2.default,
	      { tag: 'section', className: className },
	      _react2.default.createElement(Intro, { tag: 'section', dangerouslySetInnerHTML: { __html: data.intro.html } }),
	      _react2.default.createElement(
	        Awards,
	        null,
	        _react2.default.createElement(
	          AwardHeader,
	          null,
	          _react2.default.createElement(
	            _Type2.default,
	            { tag: 'h1', uppercase: true, weight: 'bold' },
	            'Awards'
	          ),
	          _react2.default.createElement(AwardIcon, null)
	        ),
	        _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: data.awards.html } })
	      ),
	      _react2.default.createElement(
	        _Hero2.default,
	        {
	          tag: 'section',
	          selectedImage: data.missionBackground,
	          bgImages: [data.missionBackground],
	          isFullHeight: true
	        },
	        _react2.default.createElement(Mission, { missionHtml: data.mission.html })
	      ),
	      _react2.default.createElement(
	        History,
	        null,
	        _react2.default.createElement(
	          _Type2.default,
	          { tag: 'h1', uppercase: true, weight: 'bold' },
	          'Our History'
	        ),
	        _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: data.history.html } })
	      ),
	      _react2.default.createElement(
	        Certs,
	        null,
	        _react2.default.createElement(
	          CertHGroup,
	          null,
	          _react2.default.createElement(
	            _Type2.default,
	            { tag: 'h1', uppercase: true, weight: 'bold' },
	            'Certifications & Associations'
	          ),
	          _react2.default.createElement(_CertificateIcon2.default, null)
	        ),
	        _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: data.certifications.html } })
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.PureComponent);
	
	About.displayName = 'About';
	About.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.shape({
	    mission: CustomPropTypes.Markdown,
	    history: CustomPropTypes.Markdown,
	    certifications: CustomPropTypes.Markdown,
	    intro: CustomPropTypes.Markdown,
	    awards: CustomPropTypes.Markdown,
	    missionBackground: CustomPropTypes.ImageSharp
	  })
	};
	exports.default = (0, _styledComponents2.default)(About)(_templateObject9);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-c4ff4e3278ec06a52310.js